import React from 'react';
import { Container } from 'reactstrap';
import './../Pages/Layout/PageLayout/PageLayout.scss';
import LoadingSpinner from './../ui/LoadingAnimations/LoadingSpinner/LoadingSpinner';

const LoadingBlank: React.FC = () => {
  return (
    <div>
      <Container tag="main">
        <LoadingSpinner />
      </Container>
    </div>
  );
};

export default LoadingBlank;
